<script setup>
import { onMounted, onBeforeUnmount, ref, computed } from 'vue'
import { useI18n } from '../i18n/index.js'
import { useConsent } from '../composables/useConsent.js'

const { t } = useI18n()
const { visible: consentVisible } = useConsent()

const THRESHOLD = 320
const show = ref(false)

function onScroll() {
  const y = window.scrollY || document.documentElement.scrollTop || 0
  show.value = y > THRESHOLD
}

function toTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

onMounted(() => {
  onScroll()
  window.addEventListener('scroll', onScroll, { passive: true })
})
onBeforeUnmount(() => window.removeEventListener('scroll', onScroll))

// 同意条出现时把按钮抬高，避免互相遮挡
const lifted = computed(() => consentVisible.value)
</script>

<template>
  <Transition name="btt">
    <button
      v-if="show"
      class="btt"
      :class="{ 'btt--lifted': lifted }"
      type="button"
      :aria-label="t('top.aria')"
      :title="t('top.aria')"
      @click="toTop"
    >
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 19V6M12 6l-6 6M12 6l6 6"
          stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"
        />
      </svg>
    </button>
  </Transition>
</template>

<style scoped>
.btt {
  position: fixed;
  right: 16px;
  bottom: calc(20px + var(--safe-bottom));
  z-index: 45;
  width: 44px; height: 44px;
  display: grid; place-items: center;
  border-radius: 50%;
  color: #fff;
  background: var(--brand);
  box-shadow: 0 6px 18px rgba(0, 0, 0, .28);
  transition: transform var(--d-fast) var(--ease-out), opacity var(--d-med) var(--ease-out);
}
.btt:active { transform: scale(.92); }
/* 同意条约占 150px 高 */
.btt--lifted { bottom: calc(172px + var(--safe-bottom)); }

.btt-enter-active, .btt-leave-active { transition: opacity var(--d-med) var(--ease-out), transform var(--d-med) var(--ease-out); }
.btt-enter-from, .btt-leave-to { opacity: 0; transform: translateY(12px) scale(.9); }
</style>
